import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {CrystalClearFrontUrl} from '../../shared/pages/crystal-clear-front-url';
import {CookieNames} from '../../shared/cookie/cookie-names';
import {CcStorageService} from '../../services/common/cc-storage.service';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  lastUrl: string = CrystalClearFrontUrl.HOME.path;
  currentView: 'login' | 'forgotPassword' | 'changePassword' | 'resetPassword' | 'expiredToken' = 'login';
  resetToken: string | undefined;
  resetMode: 'reset' | 'init' = 'reset';

  constructor(protected cookieService: CcStorageService,
              private route: ActivatedRoute,
              private router: Router) {}

  ngOnInit(): void {
    if (this.cookieService.check(CookieNames.PAGE_BEFORE_LOGOUT)) {
      this.lastUrl = this.cookieService.get(CookieNames.PAGE_BEFORE_LOGOUT);
    }
    localStorage.removeItem('username');
    localStorage.removeItem('password');

    const token = this.route.snapshot.queryParamMap.get('token');
    if (token) {
      this.resetToken = token;
      this.resetMode = this.route.snapshot.queryParamMap.get('purpose') === 'init' ? 'init' : 'reset';
      this.currentView = 'resetPassword';
    }
  }

  resetPasswordDone(): void {
    this.resetToken = undefined;
    this.currentView = 'login';
    this.router.navigate([], {relativeTo: this.route, queryParams: {}});
  }

  resetPasswordExpired(): void {
    this.resetToken = undefined;
    this.currentView = 'expiredToken';
    this.router.navigate([], {relativeTo: this.route, queryParams: {}});
  }
}
